import { create } from "zustand";
import { API_URL } from "../Config/config";
import axiosInstance from "../services/axiosInstance";
import { toast } from "react-toastify";

const usePackerDispatcher = create((set, get) => ({
    isLoading: false,
    fetchPackerDispatchers: async (filter) => {
        // console.log(filter, 'filter hhh')
        try {
            const { limit, offset } = filter;

            let URL = API_URL + "users/dashboard-packer-dispatcher-list?limit=" + limit + "&offset=" + offset;
            if(filter?.block_user) URL += "&block_user=" + filter.block_user
            if(filter?.nameOrNumber && Number(filter?.nameOrNumber)) URL += "&mobile=" + filter?.nameOrNumber
            if(filter?.nameOrNumber && (!Number(filter?.nameOrNumber))) URL += "&name=" + filter?.nameOrNumber
            if(filter?.state_id) URL += "&state_id=" + filter?.state_id.join('')
            if(filter?.district_id) URL += "&district_id=" + filter?.district_id.join('')
            if(filter?.region_id) URL += "&region_id=" + filter.region_id.join('')
            if(filter?.role_id) URL += "&role_id=" + filter.role_id

            // console.log(URL , 'formatted url')
            const result = await axiosInstance.get(URL);
            const response = result.data;

            if (response.code == 200) {
                return { status: true, data: response.data };
            } else {
                return { status: false, data: response.data };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },
    createPackerDispatcher: async (filter) => {
        console.log(filter, 'filters')
        const updatedFilter = {...filter, role: Number(filter.role)}
        try {
            let URL = API_URL + 'users/create-packer-dispatcher'

            const result = await axiosInstance.post(URL, updatedFilter)
            const response = result.data 

            return {status: true, data: response.data}
        } catch(e) {
            return {status: false, data: e.response}
        }
    },
    editPackerDispatcher: async (filter) => {
        console.log(filter, 'filters')
        const updatedFilter = {...filter, role: Number(filter.role), active_status: Number(filter.active_status)}
        try {
            let URL = API_URL + 'users/update-packer-dispatcher'

            const result = await axiosInstance.post(URL, updatedFilter)
            const response = result.data 

            return {status: true, data: response.data}
        } catch(e) {
            return {status: false, data: e.response}
        }
    },
}));

export { usePackerDispatcher };